module.exports = __webpack_public_path__ + "img/Res_Mus_1kl.d4b11707.jpg";